import React from "react";
import {useReadCompanyInfo} from "../hooks/useReadCompanyInfo";
import {companyInfoInit} from "../state";
import {useUser} from "../../../../util/userContext/UserContext";
import {
    useReadExchangeType1SelectBox,
    useReadExchangeType2SelectBox,
    useReadExchangeType3SelectBox
} from "../../../customer/correspondent/detail/hooks";
import {
    useReadExchangeRateUnitSelectBoxApi
} from "../../../customer/correspondent/detail/hooks/useReadExchangeRateUnitSelectBox";
import {useReadWonUnitSelectBox} from "../../../customer/correspondent/detail/hooks/useReadWonUnitSelectBox";
import {useDownloadCompanyReg} from "../hooks/useDownloadCompanyReg";

export default function Upper() {
    const {user} = useUser()

    const {data: companyInfoApiData} = useReadCompanyInfo({param: {id: Number(user?.userId)}, enabled: !!user})
    const companyInfo = companyInfoApiData ?? companyInfoInit

    const {mutate: mutateDownloadCompanyReg} = useDownloadCompanyReg()

    const {data: wonUnitSelect} = useReadWonUnitSelectBox();
    const {data: exchangeTypeSelect1} = useReadExchangeType1SelectBox();
    const {data: exchangeTypeSelect2} = useReadExchangeType2SelectBox();
    const {data: exchangeTypeSelect3} = useReadExchangeType3SelectBox();
    const {data: exchangeRateUnitSelect} = useReadExchangeRateUnitSelectBoxApi();

    const clickDownload = () => {
        if (companyInfo.businessFileInfo) {
            mutateDownloadCompanyReg(companyInfo.businessFileInfo)
        }
    }

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">
                자사 정보
            </h3>
            <div className="filter_toolbar">
            </div>
        </div>

        <h5 className="subheading">기본 정보</h5>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th>회사명(국문)</th>
                    <td colSpan={3}>{companyInfo.name}</td>
                    <th>대표자</th>
                    <td colSpan={3}>{companyInfo.newTxtNmCeo}</td>
                </tr>
                <tr>
                    <th>회사명(영문)</th>
                    <td colSpan={3}>{companyInfo.newTxtNameEng}</td>
                    <th>소재지</th>
                    <td colSpan={3}>{companyInfo.location}</td>
                </tr>
                <tr>
                    <th>주소</th>
                    <td colSpan={7}>{companyInfo.newTxtDcAds1H}</td>
                </tr>
                <tr>
                    <th>담당자</th>
                    <td colSpan={3}>{companyInfo.contactPersonName}</td>
                    <th>세금계산서 담당자</th>
                    <td colSpan={3}></td>
                </tr>
                <tr>
                    <th>사업자 등록증</th>
                    <td colSpan={3}>
                        <a href={void 0} className="link-underline" onClick={clickDownload}>
                            {companyInfo.businessFileInfo?.fileOrgname}
                        </a>
                    </td>
                    <th>사업자 등록번호</th>
                    <td colSpan={3}>{companyInfo.businessRegNo}</td>
                </tr>
                <tr>
                    <th style={{width: "12.25%"}}>환율기준일</th>
                    <td style={{width: "12.25%"}} className="p-4px">
                        <select className="form-select" value={companyInfo.exchangeRateCondition1} disabled>
                            <option value={undefined} hidden>-</option>
                            {exchangeTypeSelect1?.map((item) => {
                                return <option value={item.id}>{item?.name}</option>;
                            })}
                        </select>
                    </td>
                    <th style={{width: "12.25%"}}>원가단위</th>
                    <td style={{width: "12.25%"}} className="p-4px">
                        <select className="form-select" value={companyInfo.wonUnit} disabled>
                            <option value={undefined} hidden>-</option>
                            {wonUnitSelect?.map((item) => {
                                return <option value={item.id}>{item?.name}</option>;
                            })}
                        </select>
                    </td>
                    <th style={{width: "12.25%"}}>환율 지정 조건</th>
                    <td style={{width: "12.25%"}} className="p-4px">
                        <select className="form-select"
                                value={companyInfo.exchangeRateCondition2}
                                disabled>
                            <option value={undefined} hidden>-</option>
                            {exchangeTypeSelect2?.map((item) => {
                                return <option value={item.id}>{item?.name}</option>;
                            })}
                        </select>
                    </td>
                    <td style={{width: "12.25%"}} className="p-4px">
                        <select className="form-select"
                                value={companyInfo.exchangeRateCondition3} disabled>
                            <option value={undefined} hidden>-</option>
                            {exchangeTypeSelect3?.map((item) => {
                                return <option value={item.id}>{item?.name}</option>;
                            })}
                        </select>
                    </td>
                    <td style={{width: "12.25%"}} className="p-4px">
                        <select className="form-select"
                                value={companyInfo.exchangeRateUnit}
                                disabled>
                            <option value={undefined} hidden>-</option>
                            {exchangeRateUnitSelect?.map((item) => {
                                return <option value={item.id}>{item?.name}</option>;
                            })}
                        </select>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
}